export const JessicaEvents = {};

JessicaEvents.hasActiveBarEvent = () => {
  return (
    JessicaEvents.firstBarEvent() ||
    JessicaEvents.secondBarEvent() ||
    JessicaEvents.thirdBarEvent() ||
    JessicaEvents.fourthBarEvent() ||
    JessicaEvents.isFirstBlowjob() ||
    JessicaEvents.isFirstEvent() ||
    JessicaEvents.isSecondEvent()
  );
};

JessicaEvents.hasActiveEvent = () => {
  return JessicaEvents.isThirdEvent() ||
  JessicaEvents.isFourthEvent() ||
  JessicaEvents.isJessicaBeachEvent();
};

JessicaEvents.displayHint = () => {
  return JessicaEvents.isThirdEvent() ||
  JessicaEvents.isFourthEvent() ||
  JessicaEvents.isJessicaBeachEvent();
}

JessicaEvents.preEventsEventMark = () => {
  return (Yosemite.McManager.getCharisma() > 1 && Yosemite.McManager.getCharisma() < 10);
}

JessicaEvents.pickupAttempt = () => {
  if(!Yosemite.EventStateManager.pickupAttempt) {
    Yosemite.EventStateManager.pickupAttempt = true;
    Yosemite.McManager.addCharisma(1);
    YsControllers.TimeController.nextTimeDay();
    YS.Services.eventlogService.addHint('Jessica', 'Talk to her more often to raise your charisma above 7');
  }
}

/*
W barze jako nie waifu
- Have sex with Jessica
- Just say hi
 */
JessicaEvents.genericBarTalk = () => {
  return (
    !JessicaEvents.hasActiveBarEvent() && !EventStateService.isJessicaWaifu
  );
};

JessicaEvents.genericWaifuBarTalk = () => {
  return EventStateService.isJessicaWaifu;
};

/*
Po treningu charyzmy
- Buy a drink($10)
- Nevermind
 */
JessicaEvents.genericTalk_1 = () => {
  return (
    Yosemite.McManager.getCharisma() >= 7 &&
    !EventStateService.jessicaSecondEvent
  );
};

/*
Po tym jak wynajął jej mieszkanie ale w barze
- Buy a drink($10)
- Nevermind
 */
JessicaEvents.genericTalk_2 = () => {
  return EventStateService.jessicaSecondEvent;
};

JessicaEvents.firstBarEvent = () => {
  return !EventStateService.jessicaFirstBarEvent;
};

JessicaEvents.secondBarEvent = () => {
  // czy był już dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  //czy odbył się poprzedni event
  if(!EventStateService.jessicaFirstBarEvent) {
    return false;
  }

  if (Yosemite.McManager.getCharisma() <= 2) {
    return false;
  }

  return !EventStateService.jessicaSecondBarEvent;
};

JessicaEvents.thirdBarEvent = () => {
  // czy był już dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  //czy odbył się poprzedni event
  if(!EventStateService.jessicaSecondBarEvent) {
    return false;
  }

  return !EventStateService.jessicaThirdBarEvent;
};

JessicaEvents.fourthBarEvent = () => {
  // czy był już dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  //czy odbył się poprzedni event
  if(!EventStateService.jessicaThirdBarEvent) {
    return false;
  }

  return !EventStateService.jessicaFourthBarEvent;
};

JessicaEvents.isFirstBlowjob = () => {
  // czy był już dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  //czy odbył się poprzedni event
  if(!EventStateService.jessicaFourthBarEvent) {
    return false;
  }

  return !EventStateService.jessicaFirstBlowjob
};

JessicaEvents.isFirstEvent = () => {
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if (!EventStateService.secondChapterIntro) {
    return false;
  }

  // czy był BJ
  if (!EventStateService.jessicaFirstBlowjob) {
    return false;
  }

  return !EventStateService.jessicaFirstEvent;
};

JessicaEvents.isSecondEvent = () => {
  // czy był dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if (!EventStateService.secondChapterIntro) {
    return false;
  }

  // czy był BJ
  if (!EventStateService.jessicaFirstBlowjob) {
    return false;
  }

  // Czy odbył się pierwszy event
  if (!EventStateService.jessicaFirstEvent) {
    return false;
  }

  return !EventStateService.jessicaSecondEvent;
};

JessicaEvents.isThirdEvent = () => {
  // czy był dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if (!EventStateService.secondChapterIntro) {
    return false;
  }

  // czy był BJ
  if (!EventStateService.jessicaFirstBlowjob) {
    return false;
  }

  // Czy odbył się drugi event
  if (!EventStateService.jessicaSecondEvent) {
    return false;
  }

  // sprawdzanie pory dnia, event musi odbyć się w dzień
  if (
    YsControllers.TimeController.getCurrentDayTime() ===
      YsControllers.TimeController.DayTimeEnum.NIGHT ||
    YsControllers.TimeController.getCurrentDayTime() ===
      YsControllers.TimeController.DayTimeEnum.EVENING
  ) {
    return false;
  }

  return !EventStateService.jessicaThirdEvent;
};

JessicaEvents.isFourthEvent = () => {
  // czy był dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if (!EventStateService.secondChapterIntro) {
    return false;
  }

  // czy był BJ
  if (!EventStateService.jessicaFirstBlowjob) {
    return false;
  }

  // Czy odbył się trzeci event
  if (!EventStateService.jessicaThirdEvent) {
    return false;
  }

  // sprawdzanie pory dnia, event musi odbyć się po południu
  if (
    YsControllers.TimeController.getCurrentDayTime() !==
    YsControllers.TimeController.DayTimeEnum.AFTERNOON
  ) {
    return false;
  }

  return !EventStateService.jessicaFourthEvent;
};

// Jessica Beach event (with Janet);
JessicaEvents.isJessicaBeachEvent = () => {
  // czy był dziś event
  if (EventStateService.jessicaDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if (!EventStateService.secondChapterIntro) {
    return false;
  }

  // czy był BJ
  if (!EventStateService.jessicaFirstBlowjob) {
    return false;
  }

  // Czy odbył się czwarty event
  if (!EventStateService.jessicaFourthEvent) {
    return false;
  }

  return !EventStateService.jessicaBeachEvent;
};
